export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_04.cedbc5a0.jpg";